import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { BasicRegister } from 'src/app/models/basic-register.model';
import { MgService } from 'src/app/services/mg.service';
import { MatStepper } from '@angular/material/stepper';
import { BusinessUser } from 'src/app/models/business-user.model';
import { MatSnackBar } from '@angular/material/snack-bar';


@Component({
  selector: 'app-add-user',
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.scss']
})
export class AddUserComponent implements OnInit {
  @ViewChild('stepper') private myStepper: MatStepper;

  @Input()
  set business (b: BasicRegister) {
    this._business = b;
    if(this._business != null) {
      this.listUserBusiness(this._business);
    }
  }

  @Output()
  userBusinessSelected: EventEmitter<BusinessUser> = new EventEmitter<BusinessUser>()

  _loading: boolean = false;
  isLinear = false;
  firstFormGroup: UntypedFormGroup;
  secondFormGroup: UntypedFormGroup;
  thirdFormGroup: UntypedFormGroup;
  private _userBusiness: BusinessUser;
  private _business: BasicRegister;
  public items: BusinessUser[] = [];


  formAddUser: UntypedFormGroup;

  constructor(
    private fb: UntypedFormBuilder,
    private router: Router,
    private api: MgService,
    private _snackBar: MatSnackBar
  ) { }

  ngOnInit() {

    this.firstFormGroup = this.fb.group({
      firstFormGroup: [undefined, Validators.required]
    });
    this.secondFormGroup = this.fb.group({
      secondCtrl: [undefined, Validators.required]
    });

    this.formAddUser = this.fb.group({
      id: [null],
      business_id: [null, [Validators.required]],
      name: [undefined, [Validators.required]],
      email: [undefined, [Validators.required, Validators.email]],
      mobile: [undefined]//, [Validators.pattern("[0-9]{11}")]]
    })
  }

  public listUserBusiness(business: BasicRegister) {
    this._loading = true;
    this.api.listBusinessUser(business.id.toString())
      .subscribe(
        res => {
          this.items = res.data;
        },
        err => {
          console.error(err);
          this._loading = false;
        },
        () => this._loading = false,
      );
  }

  public businessSelected(value: BasicRegister) {
    this.business = value;
    this.myStepper.next();
  }

  public onSubmit() {
    this._loading = true;
    this.formAddUser.controls.business_id.setValue(this._business.id);
    this.api.createBusinessUser(this.formAddUser.value)
    .subscribe(res => this.items = res.data);
    this.openSnackBar();
    this.myStepper.reset();
    this.toBack();
  }

  public toBack(){
    history.back();
  }

  openSnackBar() {
    this._snackBar.open('Usuário Cadastrado com Sucesso', 'Fechar', {
      duration: 3000,
    });
  }

  public selectUserBusiness(value: BusinessUser) {
    this._userBusiness = value;
    this.userBusinessSelected.emit(this._userBusiness)
  }
}



